import {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { NotificationManager } from 'react-notifications';
import { StyledRefundModal } from './RefundModal.styled';
import {hideLoader, showLoader} from '../../../store/common/slice';
import {useDispatch} from "react-redux";

/**
 * @param {ServerData} client
 * */
const RefundModal = ({ show, onHide, paymentID, paymentPlanID, buildingID, client, isFuture }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState({});

    useEffect(() => {
        setData({
            title: isFuture ? t('reports.refund.future.modalTitle') : t('reports.refund.modalTitle'),
            confirmText: isFuture ? t('reports.refund.future.modalConfirmText') : t('reports.refund.modalConfirmText'),
            onSuccessText: isFuture ? t('reports.refund.future.refundNotificationSuccess') : t('reports.refund.refundNotificationSuccess'),
            onErrorText: isFuture ? 'reports.refund.future.refundNotificationError' : 'reports.refund.refundNotificationError',
        })
    }, [isFuture]);

    const sendData = async () => {
        dispatch(showLoader());
        let response;
        if (isFuture) {
            response = await client.managers.operations.shortenPlan(buildingID, paymentPlanID, { allPending: true });
        } else {
            response = await client.managers.operations.refund(buildingID, paymentID, true);
        }
        dispatch(hideLoader());
        //if response.success - change to appropriate backend response
        if (response && response.success) {
            onHide();
            NotificationManager.success(data.onSuccessText, '', 5000);
        } else {
            // todo add the reason on text. it in response.parseResponseReason
            NotificationManager.error(t(data.onErrorText, {reason: response.result?.parseResponseReason}), '', 5000);
        }
    };

    return (
        <StyledRefundModal
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header>
                <Modal.Title>{data.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="info-text">
                    <div>{data.confirmText}</div>
                </div>

                <div className="buttons-container">
                    <button
                        className="bllink-button"
                        onClick={sendData}
                    >
                        {t('reports.refund.btns.yes')}
                    </button>

                    <button
                        onClick={onHide}
                        className="btn_12"
                    >
                        {t('reports.refund.btns.no')}
                    </button>
                </div>
            </Modal.Body>
        </StyledRefundModal>
    );
};

export default RefundModal;
